// Taşeron portalı — Taşeron Yetkilisi (`supplier-contractor`) erişim kapısı (route guard UX).
//
// İki katmanlı authz (api-contract §17): yönetim ekranları (personel listesi + personel
// belgeleri, §15.2 yol B) yalnız `supplier-contractor` grant'lı **Yetkili**'ye açıktır; yalnız
// `supplier-self` grant'lı **Personeli** bunları GÖRMEZ. Asıl yetki backend'de
// (`[ModuleAction("supplier-contractor", …)]`); bu kapı yalnız UX'tir: erişim sondasının
// (useSupplierContractorAccess) sonucuna göre alt-ağacı (Outlet), 403 sayfasını veya
// "kullanılamıyor" durumunu gösterir. web-expert ContractorsGate ile aynı desen.

import { Button, Card, EmptyState, Spinner } from '@isgportal/shared';
import { ShieldAlert, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useSupplierContractorAccess } from '../lib/supplierContractorAccess';

export function SupplierContractorGate() {
  const { t } = useTranslation();
  const access = useSupplierContractorAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('access.loading')} />
      </div>
    );
  }

  // Router seviyesinde kapı: PageHeader yok → durum başlığı sayfanın tek h1'i (S37 M5).
  if (access.status === 'forbidden') {
    return (
      <Card>
        <EmptyState
          icon={ShieldAlert}
          titleAs="h1"
          title={t('access.forbidden.title')}
          description={t('access.forbidden.body')}
          action={
            <Button asChild variant="secondary">
              <Link to="/">{t('access.forbidden.back')}</Link>
            </Button>
          }
        />
      </Card>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <Card>
        <EmptyState
          icon={TriangleAlert}
          titleAs="h1"
          title={t('access.unavailable.title')}
          description={t('access.unavailable.body')}
          action={<Button onClick={access.refetch}>{t('access.unavailable.retry')}</Button>}
        />
      </Card>
    );
  }

  return <Outlet />;
}
